import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import "../css/AddDeviceNew.css";
import Cookies from "js-cookie";
// import { withStyles } from "@mui/styles";
// import { styled } from "@mui/material/styles";
import IntegrationReactSelectNew from "./IntegrationReactSelectNew";
import uniqid from "uniqid";
// import 'antd/dist/antd.css';
import ErrorText from "../ErrorText";
import deviceDriverUpdate from "../deviceDriverUpdate";
import InputBox from "./InputBox";
import _ from "lodash";
import IconButton from "@mui/material/IconButton";
import ListIcon from "@mui/icons-material/List";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip, OverlayTrigger, Overlay } from "react-bootstrap";
import * as ActionTypes from "../actions/types";
import { connect } from "react-redux";
import processDriverData from "../processDriverData";
import { Box } from "@mui/material";
// ;

//component for the add new device for the master page having device params sent in json format
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "70%",
    overflow: "auto",
    padding: "40px 90px 40px 90px",
    paddingBottom: "4%",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const customStylesSuccess = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "70%",
    overflow: "auto",
    padding: "2%",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const deviceTypeList = [
  // { label: 'light' },
  // { label: 'light_cover' },
  // { label: 'cover' },
  // { label: 'tv' },
  // { label: 'projector' },
  // { label: 'bluray' },
  // { label: 'kaleidescape' },
  // { label: 'thermostat' },
  // { label: 'avp' },
  // { label: 'lift' },
  // { label: 'toggle_lift' },
  // { label: 'swivel_lift' },
  // { label: 'media_player' },
  // { label: 'satellite' },
  // { label: 'camera' },
  // { label: 'security_system' },
  // { label: 'door_phone' },
  // { label: 'access_control' },
];

const connTypeStat = [{ label: "IP" }, { label: "RS232" }, { label: "CEC" }];

const deviceMode = [{ label: "device" }, { label: "utility" }];

const ioType = [
  { label: "input" },
  { label: "output" },
  { label: "process" },
  { label: "other" },
];

const styles = (theme) => ({
  root: {
    display: "flex",
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
    border: "none",
  },
  selectEmpty: {
    // marginTop: theme.spacing.unit * 2,
    width: "100%",
  },
  margin: {
    // margin: theme.spacing.unit,
    // margin: 0,
    width: "10px",
  },
  extendedIcon: {
    // marginRight: theme.spacing.unit,
  },
});

class EditDeviceNew extends React.PureComponent {
  constructor(props) {
    super(props);

    // 🔹 Extract driver data from props
    let driverType = "";
    let driverVersion = "";
    let driverPath = "";
    let document = "";
    if (props.device.drivers && props.device.drivers.length > 0) {
      driverType = props.device.drivers[0].driver_type || "";
      driverVersion = props.device.drivers[0].version || "";
      driverPath = props.device.drivers[0].driver_path || "";
      document = props.device.drivers[0].document_path || "";
    }

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalIsOpenSuccess: false,
      allError: [],
      showErrorMessage: false,
      modalStateAftereOpen: "animated animated-duration-custom slideInDown",
      modalStateAftereOpenSuccess:
        "animated animated-duration-custom slideInDown",

      // states for adding/editing device:
      deviceType: props.device.device_type,
      deviceName: props.device.device_name,
      deviceModel: props.device.device_model,
      deviceConnectionType: props.device.device_connection,
      deviceMode: props.device.device_group,
      deviceNotes: props.device.device_notes,
      ioType: props.device.device_io,
      notes: "",
      noOfExtraField: "",
      extraFields: [],
      errorMessage: [],
      driverData: [],

      // 🔹 Driver form fields
      devicedriverData: props.device.drivers ? [...props.device.drivers] : [],
      driverType: driverType,
      driverVersion: driverVersion,
      driverFile: null, // for file upload
      driverPath: driverPath, // existing file link
      document: document,

      errorInJSON: false,
      showErrorMessageJSON: false,
      validateDriverData: false,
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  componentWillMount() {
    let path = "root";

    let xx = this.JsonToRawEdit(this.props.device.device_extra_field, path);
    this.props.deviceUpdate(xx);
  }

  closeModalSuccess() {
    let uniquePath = uniqid();
    let xx = [
      {
        paramField: "",
        paramUniqueKey: uniquePath,
        paramValues: [
          {
            paramField: "",
            paramUniqueKey: uniqid(),
            paramValues: [],
            path: `root/0/${uniquePath}/0`,
            type: "root",
          },
        ],
        path: "root/0",
        type: "root",
      },
    ];
    this.props.deviceUpdate(xx);
    this.setState(
      {
        modalStateAftereOpenSuccess:
          "animated animated-duration-custom slideOutUp",
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpenSuccess: false,
            },
            () => this.props.refreshDevice()
          );
        }, 500);
      }
    );
  }

  closeModal(e) {
    e.preventDefault();
    let uniquePath = uniqid();
    let xx = [
      {
        paramField: "",
        paramUniqueKey: uniquePath,
        paramValues: [
          {
            paramField: "",
            paramUniqueKey: uniqid(),
            paramValues: [],
            path: `root/0/${uniquePath}/0`,
            type: "root",
          },
        ],
        path: "root/0",
        type: "root",
      },
    ];
    this.props.deviceUpdate(xx);
    this.setState(
      {
        modalStateAftereOpen: "animated animated-duration-custom slideOutUp",
        //states for adding device:
        deviceType: "",
        deviceName: "",
        deviceModel: "",
        deviceConnectionType: "",
        deviceMode: "",
        ioType: "",
        notes: "",
        errorMessage: [],
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpen: false,
            },
            () => {
              this.props.refreshDevice();
            }
          );
        }, 500);
      }
    );
  }

  handleChangeInputBox = (name, event) => {
    let xx = {
      errorField: name,
      errorContent: event,
    };
    let allError = this.state.allError;

    let compressedError = _.remove(allError, (e) => {
      return e[name] !== "";
    });
    allError.push(xx);

    this.setState({
      [name]: event,
      allError: compressedError,
    });
  };

  AddDevice = (e) => {
    e.preventDefault();
    if (!this.state.errorInJSON) {
      this.fetchError((e) => {
        if (e === "NoError") {
          this.setState(
            {
              loader: true,
            },
            () => this.EditDeviceNew()
          );
        }
      });
    }
  };

  validateDriverData = (e) => {
    e.preventDefault();
    this.setState(
      {
        showErrorMessageJSON: true,
        errorInJSON: false,
        validateDriverData: true,
        showErrorMessage: true,
      },
      () => {
        if (this.props.redux.auth.deviceApi.length !== 0) {
          // this.countMyArray(this.state.extraFields)
          this.countMyArray(this.props.redux.auth.deviceApi);
        } else {
          this.setState({
            errorInJSON: true,
          });
        }
      }
    );
  };

  JsonToRawEdit = (data, path) => {
    var newData = [];

    if (!Array.isArray(data)) {
      let propertyKeys = Object.keys(data);
      if (propertyKeys === undefined) {
        return [
          {
            paramField: "",
            paramUniqueKey: "sdfsdf",
            paramValues: [],
            path: `root/0`,
            type: "root",
          },
        ];
      }
      propertyKeys.forEach((upperValue, index) => {
        if (typeof data[propertyKeys[index]] === "string") {
          let uniqidPath = uniqid();
          let rawData = {
            paramField: data[propertyKeys[index]],
            paramUniqueKey: uniqidPath,
            paramValues: [],
            path: `${path}/${index}`,
            type: "root",
          };
          newData.push(rawData);
        } else {
          let uniqidPath = uniqid();
          let rawData = {
            paramField: upperValue,
            paramUniqueKey: uniqidPath,
            paramValues: this.JsonToRawEdit(
              data[propertyKeys[index]],
              `${path}/${index}/${uniqidPath}`
            ),
            path: `${path}/${index}`,
            type: "root",
          };
          newData.push(rawData);
        }
      });
    } else if (Array.isArray(data)) {
      data.forEach((upperValue, index) => {
        let uniqidPath = uniqid();
        let rawData = {
          paramField: upperValue,
          paramUniqueKey: uniqidPath,
          paramValues: [],
          path: `${path}/${index}`,
          type: "root",
        };
        newData.push(rawData);
      });
    }

    return newData;
  };

  fetchError = (noErrorCallBack) => {
    var errorMessage = [];

    this.setState({
      showErrorMessage: true,
    });

    if (this.state.deviceType.length === 0) {
      errorMessage.push("Device type missing or incorrect");
    }
    if (this.state.deviceName.length === 0) {
      errorMessage.push("Device name missing or incorrect");
    }
    if (this.state.deviceModel.length === 0) {
      errorMessage.push("Device model missing or incorrect");
    }
    if (this.state.deviceNotes.length === 0) {
      errorMessage.push("Device notes missing or incorrect");
    }
    if (this.state.deviceConnectionType.length === 0) {
      errorMessage.push("Device connection type missing or incorrect");
    }
    if (this.state.deviceMode.length === 0) {
      errorMessage.push("Device mode missing or incorrect");
    }

    if (this.state.deviceMode === "device") {
      if (this.state.ioType.length === 0) {
        errorMessage.push("Device input/output type missing or incorrect");
      }
    }

    this.setState(
      {
        errorMessage: errorMessage,
      },
      () => {
        if (this.state.errorMessage.length === 0) {
          noErrorCallBack("NoError");
        }
      }
    );
  };

  countMyArray = (someArray) => {
    someArray.forEach((element) => {
      if (ErrorText("notEmpty", element.paramField) !== "No Error") {
        this.setState({
          errorInJSON: true,
        });
      }
      if (element.paramValues.length !== 0) {
        this.countMyArray(element.paramValues);
      }
    });
  };

  // EditDeviceNew = (e) => {
  //   let device_type = this.state.deviceType;
  //   let device_name = this.state.deviceName;
  //   let device_model = this.state.deviceModel;
  //   let device_connection = this.state.deviceConnectionType;
  //   let device_group = this.state.deviceMode;
  //   let device_io = this.state.ioType;
  //   let device_notes = this.state.deviceNotes;
  //   let device_extra_field = processDriverData(this.props.redux.auth.deviceApi);

  //   var tokenStored = localStorage.getItem('token');
  //   tokenStored = `Token ${tokenStored}`;
  //   var headers = {
  //     'Content-Type': 'application/json',
  //     "Access-Control-Allow-Origin": "*",
  //     'X-CSRFToken': localStorage.getItem('csrftoken'),
  //     'Authorization': tokenStored
  //   };

  //   const requestBody = {
  //     device_id: this.props.device.device_id,
  //     device_type: device_type,
  //     device_name: device_name,
  //     device_model: device_model,
  //     device_connection: device_connection.map(item => ({
  //       label: item,
  //       value: item
  //     })),
  //     device_group: device_group,
  //     device_io: device_io,
  //     device_params: '',
  //     device_api: '',
  //     device_notes: device_notes,
  //     device_extra_field: device_extra_field,

  //     // ✅ Include drivers from your state
  //     drivers: this.state.devicedriverData.map(driver => ({
  //       driver_type: driver.driver_type,
  //       version: driver.version,
  //       driver_path: driver.driver_path || null, // keep existing path if available
  //       newFile: driver.newFile || null // if uploading new file
  //     }))
  //   };

  //   console.log("Sending requestBody:", requestBody);

  //   fetch(`/cloud/device_cloudApi_Detail/${this.props.device.device_id}`, {
  //     method: "PUT",
  //     headers: headers,
  //     body: JSON.stringify(requestBody),
  //   })
  //     .then(response => {
  //       if (response.status === 403) {
  //         localStorage.removeItem('token');
  //         localStorage.removeItem('csrftoken');
  //         localStorage.removeItem('auth');
  //         window.location.href = '/session-timeout';
  //       } else {
  //         return response.json();
  //       }
  //     })
  //     .then(data => {
  //       if (data.message === 'failure') {
  //         var errorMessage = [];
  //         errorMessage.push(data.data.device_model[0]);
  //         this.setState({
  //           errorMessage: errorMessage
  //         });
  //         alert(data.data.device_model[0]);
  //       } else {
  //         this.setState({
  //           modalIsOpen: false,
  //           modalIsOpenSuccess: true
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  EditDeviceNew = (e) => {
    const {
      deviceType,
      deviceName,
      deviceModel,
      deviceConnectionType,
      deviceMode,
      ioType,
      deviceNotes,
      devicedriverData,
    } = this.state;

    const device_extra_field = processDriverData(
      this.props.redux.auth.deviceApi
    );
    const tokenStored = `Token ${localStorage.getItem("token")}`;

    // FormData for JSON + files
    const formData = new FormData();

    // Build JSON payload
    const requestBody = {
      device_id: this.props.device.device_id,
      device_type: deviceType,
      device_name: deviceName,
      device_model: deviceModel,
      device_connection: deviceConnectionType.map((item) => ({
        label: item,
        value: item,
      })),
      device_group: deviceMode,
      device_io: ioType,
      device_params: "",
      device_api: "",
      device_notes: deviceNotes,
      device_extra_field,
      drivers: devicedriverData.map((driver) => ({
        id: driver.id || null, // Existing driver ID or null
        driver_type: driver.driver_type,
        version: driver.version,
        driver_path: driver.driver_path || null, // Existing path
        package_name: driver.file_name || "",
        document_path: driver.document_path || null,
        document_name: driver.file_docname || "",
        // File name for display
      })),
    };

    // Append JSON payload
    formData.append("data", JSON.stringify(requestBody));

    // Append actual new files
    devicedriverData.forEach((driver, index) => {
      if (driver.file_obj instanceof File) {
        formData.append(`file_${index}`, driver.file_obj); // Send the file
      }
    });

    fetch(`/cloud/device_cloudApi_Detail/${this.props.device.device_id}`, {
      method: "PUT",
      headers: {
        Authorization: tokenStored,
        "X-CSRFToken": localStorage.getItem("csrftoken"),
      },
      body: formData,
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.message === "failure") {
          alert(data.data.device_model[0]);
          this.setState({ errorMessage: [data.data.device_model[0]] });
        } else {
          this.setState({ modalIsOpen: false, modalIsOpenSuccess: true });
        }
      })
      .catch((err) => console.log(err));
  };

  onSelectChange = (operationMode, valueSelect) => {
    // console.log(operationMode);
    // console.log(valueSelect);
    let xx = {
      errorField: operationMode,
      errorContent: valueSelect,
    };
    let allError = this.state.allError;
    allError.push(xx);

    if (operationMode === "deviceType") {
      this.setState({
        deviceType: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "deviceMode") {
      this.setState({
        deviceMode: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "connType") {
      this.setState({
        deviceConnectionType: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "ioType") {
      this.setState({
        ioType: valueSelect,
        errorMessage: [],
        allError,
      });
    }
  };

  errorLog = (data) => {
    let errorLog = {
      ...this.props.redux.auth.deviceDriverError,
      [data.path]: data.paramField === "" ? true : false,
    };
    if (data.paramValues.length === 0) {
      this.props.deviceError(errorLog);
    } else {
      this.props.deviceError(errorLog);
      let dataNew = {
        ...data.paramValues[0],
      };
      this.errorLog(dataNew);
    }
  };

  renderBoxTypeFirst = (data, callBackRoot) => {
    let dataLength = data.length;
    callBackRoot = (path, data, type, position) => {
      if (type === "root") {
        let uniquePath = uniqid();
        let lastIndexValue = path.lastIndexOf("/");
        let extractedPath = path.substring(lastIndexValue + 1, path.length);
        let previousPath = path.substring(0, lastIndexValue);
        let dataNew = {
          paramField: "",
          paramUniqueKey: uniquePath,
          paramValues: [
            {
              paramField: "",
              paramUniqueKey: uniquePath,
              paramValues: [],
              path: `${previousPath}/${dataLength}/${uniquePath}/0`,
              type: "root",
            },
          ],
          path: `${previousPath}/${data.length}`,
          type: "root",
        };
        data.push(dataNew);
        this.errorLog(dataNew);
        let searchingData = this.props.redux.auth.deviceApi;
        let lastIndexValueNew = path.lastIndexOf("/");
        let extractedPathNew = path.substring(0, lastIndexValueNew);
        let lastIndexValueSecond = extractedPathNew.lastIndexOf("/");
        let extractedPathSecond = extractedPathNew.substring(
          0,
          lastIndexValueSecond
        );
        let someData = this.iterateOverObj(
          extractedPathSecond,
          searchingData,
          dataNew
        );
        this.updateDeviceData(path, someData);
      } else if (type === "fruit") {
        let uniquePath = uniqid();
        let lastIndexValue = path.lastIndexOf("/");
        let extractedPath = path.substring(lastIndexValue + 1, path.length);
        let previousPath = path.substring(0, lastIndexValue);
        let dataNew = {
          paramField: "",
          paramUniqueKey: uniquePath,
          paramValues: [],
          path: `${previousPath}/${data.length}`,
          type: "root",
        };
        data.push(dataNew);
        this.errorLog(dataNew);
        let searchingData = this.props.redux.auth.deviceApi;
        let lastIndexValueNew = path.lastIndexOf("/");
        let extractedPathNew = path.substring(0, lastIndexValueNew);
        let lastIndexValueSecond = extractedPathNew.lastIndexOf("/");
        let extractedPathSecond = extractedPathNew.substring(
          0,
          lastIndexValueSecond
        );
        let someData = this.iterateOverObj(
          extractedPathSecond,
          searchingData,
          dataNew
        );
        this.updateDeviceData(path, someData);
      }
    };
    let element = "";
    if (data.length !== undefined) {
      element = data.map((e, index) => {
        let innerElement = "";
        let valueParam = "";
        if (e.type === "root") {
          valueParam = e.paramField;
          if (e.paramValues.length !== 0) {
            innerElement = this.renderBoxTypeFirst(e.paramValues);
          }
        } else if (e.type === "fruit") {
          valueParam = e.paramField;
        }
        return (
          <React.Fragment>
            {/* <div style={{ marginLeft: e.path.length<= 8 ? '0px' : '20px' }}> */}
            <div style={{ marginLeft: "20px" }}>
              {this.state.showErrorMessageJSON &&
              ErrorText("notEmpty", valueParam) !== "No Error" ? (
                <span className="small text-danger">Not a valid input</span>
              ) : (
                <span></span>
              )}
              <div class="d-flex bd-highlight">
                <div class="p-2 flex-grow-1 bd-highlight">
                  <input
                    type="text"
                    class="form-control"
                    value={valueParam}
                    onChange={(x) => {
                      if (x.target.value.length <= 50) {
                        let updatedData = deviceDriverUpdate(
                          e.path,
                          this.props.redux.auth.deviceApi,
                          x.target.value,
                          "add"
                        );
                        let errorLog = this.props.redux.auth.deviceDriverError;
                        errorLog = {
                          ...this.props.redux.auth.deviceDriverError,
                          [e.path]: x.target.value === "" ? true : false,
                        };
                        this.props.deviceError(errorLog);
                        this.updateDeviceData("paramKey", updatedData);
                        this.setState({
                          extraFields: updatedData,
                          errorInJSON: false,
                          validateDriverData: false,
                        });
                      }
                    }}
                  />
                </div>
                {data.length !== 1 ? (
                  <OverlayTrigger
                    placement="auto"
                    display={false}
                    overlay={<Tooltip id="overlay-example">Delete</Tooltip>}
                  >
                    <div>
                      <React.Fragment>
                        <IconButton aria-label="Delete">
                          <DeleteIcon
                            onClick={(x) => {
                              this.setState(
                                {
                                  errorInJSON: false,
                                  validateDriverData: false,
                                },
                                () => {
                                  let updatedData = deviceDriverUpdate(
                                    e.path,
                                    this.props.redux.auth.deviceApi,
                                    "delete",
                                    "delete"
                                  );
                                  this.props.deviceUpdate(updatedData);
                                }
                              );
                            }}
                          />
                        </IconButton>
                      </React.Fragment>
                    </div>
                  </OverlayTrigger>
                ) : null}
                <React.Fragment>
                  {data.length === index + 1 && e.path.length <= 31 ? (
                    <OverlayTrigger
                      placement="auto"
                      display={false}
                      overlay={
                        <Tooltip id="overlay-example">With Label</Tooltip>
                      }
                    >
                      <div>
                        <React.Fragment>
                          <IconButton aria-label="Delete">
                            <ListIcon
                              onClick={(someRender) => {
                                this.setState(
                                  {
                                    errorInJSON: false,
                                    validateDriverData: false,
                                  },
                                  () => {
                                    someRender.preventDefault();
                                    callBackRoot(e.path, data, "root", index);
                                  }
                                );
                              }}
                            />
                          </IconButton>
                        </React.Fragment>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                  {e.paramValues.length === 0 && data.length === index + 1 ? (
                    <OverlayTrigger
                      placement="auto"
                      display={false}
                      overlay={
                        <Tooltip id="overlay-example">Without Label</Tooltip>
                      }
                    >
                      <div>
                        <React.Fragment>
                          <IconButton aria-label="Delete">
                            <AddIcon
                              onClick={(someRender) => {
                                this.setState(
                                  {
                                    errorInJSON: false,
                                    validateDriverData: false,
                                  },
                                  () => {
                                    someRender.preventDefault();
                                    callBackRoot(e.path, data, "fruit", index);
                                  }
                                );
                              }}
                            />
                          </IconButton>
                        </React.Fragment>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                </React.Fragment>
              </div>
              {innerElement}
            </div>
          </React.Fragment>
        );
      });
    }
    return element;
  };

  updateDeviceData = (path, updatePartialData) => {
    let previousState = this.props.redux.auth.deviceApi;
    this.props.deviceUpdate(updatePartialData);
  };

  iterateOverObj = (path, searchingData, injectionData) => {
    let iterateAgain = true;
    iterateAgain = searchingData.some((e) => {
      if (e.path === path) {
        // searchingData['paramValues'] = injectionData;
        iterateAgain = false;
      } else if (path === "") {
        iterateAgain = false;
      }
    });
    if (iterateAgain) {
      searchingData.forEach((e) => {
        this.iterateOverObj(path, searchingData.paramValues, injectionData);
      });
    }
    if (!iterateAgain) {
      return searchingData;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          style={customStyles}
          className={this.state.modalStateAftereOpen}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3
            className="modal-heading text-uppercase mb-0"
            style={{
              color: "#888888",
              fontSize: "30px",
              marginBottom: "30px",
              marginLeft: "-12px",
            }}
          >
            Edit Device
          </h3>
          <form>
            <div className="row">
              <div className="col-6 mt-3 pl-1 disableEvent">
                <IntegrationReactSelectNew
                  placeholder=""
                  multipleSelect={false}
                  content={deviceTypeList}
                  onSelect={this.onSelectChange.bind(this, "deviceType")}
                  IntegrationReactSelectNewLabel="Device Type"
                  errorText={
                    this.state.deviceType === "" && this.state.showErrorMessage
                      ? "Please select device mode"
                      : ""
                  }
                  someText={this.state.deviceType}
                  disableEvent={true}
                />
              </div>
              <div className="col-6 mt-0 px-0">
                <InputBox
                  inputText={this.state.deviceName}
                  error={
                    ErrorText("notEmpty", this.state.deviceName) !==
                      "No Error" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceName) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device name must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceName}
                  placeholder="Device Name"
                  inputBoxName="deviceName"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div
                className="col-6 mb-2 p-0 disableEvent"
                style={{ marginLeft: "-4px" }}
              >
                <InputBox
                  inputText={this.state.deviceModel}
                  error={
                    this.state.deviceModel === "" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceModel) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device model must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceModel}
                  placeholder="Device Model(Must be unique)"
                  inputBoxName="deviceModel"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  disableEvent={true}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div className="col-6 mb-2 px-0" style={{ marginLeft: "4px" }}>
                <InputBox
                  inputText={this.state.deviceNotes}
                  error={
                    this.state.deviceNotes === "" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceNotes) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device notes must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceNotes}
                  placeholder="Device Notes"
                  inputBoxName="deviceNotes"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div
                className="col-6 mt-3 mb-3 "
                style={{ marginLeft: "-10px", paddingRight: "0px" }}
              >
                <IntegrationReactSelectNew
                  placeholder="Device Mode"
                  multipleSelect={false}
                  content={deviceMode}
                  onSelect={this.onSelectChange.bind(this, "deviceMode")}
                  IntegrationReactSelectNewLabel="Device Mode"
                  errorText={
                    this.state.deviceMode === "" && this.state.showErrorMessage
                      ? "Please select device mode"
                      : ""
                  }
                  someText={this.state.deviceMode}
                />
                {this.state.deviceMode === "device" ? (
                  <div className="col-12 text-field-modal pl-0 mt-4 pr-0">
                    <IntegrationReactSelectNew
                      placeholder="Input / Output Type"
                      multipleSelect={false}
                      content={ioType}
                      onSelect={this.onSelectChange.bind(this, "ioType")}
                      IntegrationReactSelectNewLabel="Input / Output Type"
                      errorText={
                        this.state.ioType === "" && this.state.showErrorMessage
                          ? "Please select Input / output type"
                          : ""
                      }
                      someText={this.state.ioType}
                    />
                  </div>
                ) : null}
              </div>
              <div
                className="col-6 mt-3 mb-3"
                style={{
                  paddingRight: "0px",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
              >
                <IntegrationReactSelectNew
                  placeholder="Connection Type"
                  multipleSelect={true}
                  someText={this.state.deviceConnectionType}
                  haveDefault={true}
                  defaultValue={this.state.deviceConnectionType}
                  content={connTypeStat}
                  onSelect={this.onSelectChange.bind(this, "connType")}
                  IntegrationReactSelectNewLabel="Connection Type"
                  errorText={
                    this.state.deviceConnectionType === 0 &&
                    this.state.showErrorMessage
                      ? "Please select connection type"
                      : ""
                  } // length value changed to [] -> 0
                  // errorText={this.state.deviceConnectionType === [] && this.state.showErrorMessage ? 'Please select connection type' : ''}
                />
              </div>
              <div className="col-12 m-0 p-0">
                {this.renderBoxTypeFirst(this.props.redux.auth.deviceApi)}
                {this.state.validateDriverData ? (
                  this.state.errorInJSON ? (
                    <div className="text-danger">Not a valid driver data.</div>
                  ) : (
                    <div className="text-success">Driver data validated.</div>
                  )
                ) : (
                  ""
                )}
              </div>
              <div className="col-12 mt-4">
                <div className="col-12 mt-4">
                  <h5>Drivers</h5>

                  {/* ======= Add Driver Section (Top) ======= */}
                  <div className="card mb-4">
                    <div className="card-header">
                      <strong>Add New Driver</strong>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <select
                            value={this.state.newDriverType || ""}
                            onChange={(e) =>
                              this.setState({ newDriverType: e.target.value })
                            }
                            className="form-control"
                          >
                            <option value="">Select Driver Type</option>
                            <option value="custom">custom</option>
                            <option value="Inbuilt">Inbuilt</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <input
                            type="text"
                            placeholder="Version"
                            value={this.state.newDriverVersion || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              const regex = /^\d*\.?\d*\.?\d*$/; // allow typing X, X., X.Y, X.Y., X.Y.Z

                              if (regex.test(value)) {
                                this.setState({
                                  newDriverVersion: value,
                                  newDriverVersionError: false,
                                });
                              } else {
                                this.setState({ newDriverVersionError: true });
                              }
                            }}
                            className="form-control"
                          />
                          {this.state.newDriverVersionError && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                              Version must be in format X.Y.Z (e.g., 1.0.0)
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <Box>
                            <label
                              htmlFor="driver-upload"
                              style={{
                                fontWeight: "bold",
                                display: "block",
                                paddingBlockStart:"25px",
                                marginBottom: "4px",
                                color: "#666",
                              }}
                            >
                              Upload Driver File
                            </label>
                            <input
                              id="driverFileInput"
                              type="file"
                              accept=".zip,.bin"
                              onChange={(e) =>
                                this.setState({
                                  newDriverFile: e.target.files[0],
                                })
                              }
                              className="form-control"
                              style={{ padding: "0.375rem 3.70rem" }}
                            />
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box>
                            <label
                              htmlFor="documentFileInput"
                              style={{
                                fontWeight: "bold",
                                display: "block",
                                marginBottom: "6px",
                                paddingBlockStart:"25px",
                                color: "#444",
                              }}
                            >
                              Upload Document
                            </label>

                            <input
                              id="documentFileInput"
                              type="file"
                              accept=".pdf,.doc,.docx"
                              onChange={(e) =>
                                this.setState({
                                  newDriverDocFile: e.target.files[0],
                                })
                              }
                              className="form-control"
                              style={{
                                padding: "0.375rem 0.75rem", // standard bootstrap padding
                                borderRadius: "8px", // smoother corners
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                cursor: "pointer",
                              }}
                            />
                          </Box>
                        </div>


                        <div className="col-md-2">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={() => {
                              if (
                                !this.state.newDriverType ||
                                !this.state.newDriverVersion ||
                                !this.state.newDriverFile ||
                                !this.state.newDriverDocFile
                              ) {
                                alert(
                                  "Please select driver type, enter version, and upload a file."
                                );
                                return;
                              }
                              const versionRegex = /^\d+\.\d+\.\d+$/;
                              if (
                                !versionRegex.test(this.state.newDriverVersion)
                              ) {
                                alert(
                                  "Version format must be X.Y.Z (e.g., 1.0.0)"
                                );
                                return;
                              }

                              let newData = [
                                ...this.state.devicedriverData,
                                {
                                  driver_type: this.state.newDriverType,
                                  version: this.state.newDriverVersion,
                                  file_name: this.state.newDriverFile.name,
                                  file_docname: this.state.newDriverDocFile
                                    .name,
                                  file_obj: this.state.newDriverFile,
                                  file_doc: this.state.newDriverDocFile,
                                },
                              ];

                              this.setState({
                                devicedriverData: newData,
                                newDriverType: "",
                                newDriverVersion: "",
                                newDriverFile: null,
                                newDriverDocFile: null,
                              });

                              // Reset file input
                              document.getElementById("driverFileInput").value =
                                "";
                            }}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ======= Existing Drivers Table (No Delete Button) ======= */}
                {this.state.devicedriverData &&
                this.state.devicedriverData.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Driver Type</th>
                        <th>Version</th>
                        <th>File</th>
                        <th>documentation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.devicedriverData.map((driver, idx) => (
                        <tr key={idx}>
                          <td>{driver.driver_type}</td>
                          <td>{driver.version}</td>
                          <td>
                            {driver.file_name ? (
                              <span>{driver.file_name}</span> // New driver, show uploaded file name
                            ) : driver.driver_path ? (
                              <a
                                href={driver.driver_path}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View File
                              </a> // Existing driver, show link
                            ) : null}
                          </td>
                          <td>
                            {driver.file_docname ? (
                              <span>{driver.file_docname}</span> // New driver, show uploaded file name
                            ) : driver.document_path ? (
                              <a
                                href={driver.document_path}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View Documentation
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No drivers added yet.</p>
                )}
              </div>

              <div className="row w-100 my-3">
                <div className="ml-auto">
                  <button
                    className="btn btn-new-grey"
                    style={{ marginRight: "15px" }}
                    onClick={this.closeModal}
                  >
                    Cancel
                  </button>
                  {this.state.validateDriverData ? (
                    this.state.errorInJSON ? (
                      <button
                        className="btn btn-new-orange float-right"
                        onClick={this.validateDriverData.bind(this)}
                      >
                        Validate Driver Data
                      </button>
                    ) : (
                      <button
                        className="btn btn-new-green"
                        onClick={this.AddDevice.bind(this)}
                        style={{ marginLeft: "15px" }}
                      >
                        Edit Device
                      </button>
                    )
                  ) : (
                    <button
                      className="btn btn-new-orange float-right"
                      onClick={this.validateDriverData.bind(this)}
                    >
                      Validate Driver Data
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </Modal>
        {/* Drivers Table + Edit/Add */}

        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div
              className="float-right cross-times"
              onClick={this.closeModalSuccess}
            >
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">
              Device edited successfully
            </h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div
              className="btn reset-btn mx-2 px-5"
              onClick={this.closeModalSuccess}
            >
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

EditDeviceNew.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchBarActivate: (data) =>
      dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    deviceUpdate: (data) => dispatch({ type: ActionTypes.DEVICE, data: data }),
    deviceError: (data) =>
      dispatch({ type: ActionTypes.DRIVERERROR, data: data }),
    deviceErrorClean: (data) =>
      dispatch({ type: ActionTypes.DRIVERERRORCLEAN, data: data }),
  };
};
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDeviceNew));
export default connect(mapStateToProps, mapDispatchToProps)(EditDeviceNew);
